// @generated by liquid-inject from src/assets/algolia-shared.ts
// src/shared/algolia/constants.ts
var CDN_ALGOLIASEARCH = "https://cdn.jsdelivr.net/npm/algoliasearch@5.56.0/dist/lite/builds/browser.umd.js";
var SRI_ALGOLIASEARCH = "sha384-jydndPKly6IFOH8FPmOV3qHV/YxfBbkZBbaNHhojUEnFzJpw458cQC2x80yc6cdb";
var CDN_INSTANTSEARCH = "https://cdn.jsdelivr.net/npm/instantsearch.js@4.107.0/dist/instantsearch.production.min.js";
var SRI_INSTANTSEARCH = "sha384-jQzNjxEgDf9zvtGMhSQ2tONwoAaad2xzhQAgXKs5ULIao/KSpT/4eC0ddEYvq2S7";
var CDN_AUTOCOMPLETE_CORE = "https://cdn.jsdelivr.net/npm/@algolia/autocomplete-core@1.19.9/dist/umd/index.production.js";
var SRI_AUTOCOMPLETE_CORE = "sha384-edA9yEIv/c1TvTpVphdnCDBNwviW2ZLHEzVX2+5MYTlH5/D5o9pjkkk3xXn0uadH";
var SEARCH_DEBOUNCE_MS = 200;
var ALGOLIA_PRODUCT_ATTRIBUTES_TO_RETRIEVE = [
  "objectID",
  "id",
  "handle",
  "url",
  "title",
  "image",
  "price",
  "available",
  "inventory_available",
  "inventory_quantity",
  "variant_id",
  "template_suffix",
  "tags",
  "contenance",
  "subtitle",
  "related_products",
  "meta.custom.subtitle",
  "meta.custom.label",
  "meta.custom.contenance",
  "meta.custom.capacity",
  "meta.custom.format",
  "meta.custom.media_tags",
  "meta.custom.product_tags",
  "meta.custom.related_products",
  "meta.custom.gift_product",
  "meta.custom.preorder",
  "meta.bundle"
];
var ALGOLIA_HIDDEN_PRODUCTS_FILTER = "NOT meta.seo.hidden:1";
var ALGOLIA_HIDDEN_GUARD_CONTEXT = "hidden-guard";
var ALGOLIA_PRODUCT_RESPONSE_FIELDS = [
  "hits",
  "facets",
  "facets_stats",
  "nbHits",
  "nbPages",
  "page",
  "renderingContent",
  "userData",
  "query"
];

// src/shared/algolia/dom.ts
function escapeHtml(value) {
  return String(value ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

// src/shared/algolia/load-script.ts
var pending = /* @__PURE__ */ new Map();
function loadScript(src, integrity) {
  const cached = pending.get(src);
  if (cached) return cached;
  const promise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.crossOrigin = "anonymous";
    if (integrity) script.integrity = integrity;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
  pending.set(src, promise);
  return promise;
}

// src/shared/algolia/query.ts
var MIN_QUERY_LEN = 3;
function parseShortQueries(value) {
  return (value ?? "").split(/[\n,]/).map((item) => item.trim().toLowerCase()).filter(Boolean);
}
function minimumQueryLength(query, shortQueries) {
  const normalizedQuery = query.trim().toLowerCase();
  if (shortQueries.includes(normalizedQuery)) return normalizedQuery.length;
  return MIN_QUERY_LEN;
}

// src/shared/algolia/urls.ts
function shopifyRoot() {
  return window.Shopify?.routes?.root ?? "/";
}
function joinRootUrl(root, path) {
  return `${root.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}
function declaredKind(hit) {
  const declared = [hit.type, hit.object_type];
  if (declared.includes("collection")) return "collection";
  if (declared.includes("product")) return "product";
  const id = String(hit.objectID ?? "");
  if (id.includes("/Collection/")) return "collection";
  if (id.includes("/Product/")) return "product";
  if (hit.products_count !== void 0) return "collection";
  if (hit.product_type !== void 0) return "product";
  return null;
}
function itemUrl(hit, fallbackKind = "product") {
  if (hit.url) return hit.url;
  if (!hit.handle) return "#";
  const kind = declaredKind(hit) ?? fallbackKind;
  return joinRootUrl(
    shopifyRoot(),
    `${kind === "collection" ? "collections" : "products"}/${hit.handle}`
  );
}
function searchUrlFor(query) {
  const root = shopifyRoot();
  const normalizedRoot = root.endsWith("/") ? root : `${root}/`;
  return `${normalizedRoot}search?q=${encodeURIComponent(query)}`;
}
var RESOURCE_PATHS = {
  Collection: "collections",
  Page: "pages",
  Product: "products"
};
function resourceUrl(resource) {
  if (!resource) return "";
  return joinRootUrl(
    shopifyRoot(),
    `${RESOURCE_PATHS[resource.typename]}/${resource.handle}`
  );
}
function normalizeUrl(value) {
  if (!value) return "";
  if (value.startsWith("#") || value.startsWith("http://") || value.startsWith("https://")) {
    return value;
  }
  if (!value.startsWith("/")) return "";
  const root = shopifyRoot();
  if (root === "/" || value.startsWith(root)) return value;
  return joinRootUrl(root, value);
}

// src/shared/algolia/icons.ts
var ICON_BULLET = `<svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' viewBox='0 0 17 16' fill='none'><path d='M9.5 8C9.5 8.55228 9.05228 9 8.5 9C7.94772 9 7.5 8.55228 7.5 8C7.5 7.44772 7.94772 7 8.5 7C9.05228 7 9.5 7.44772 9.5 8Z' fill='currentColor'/></svg>`;
var ICON_CROSS_SVG = `<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' aria-hidden='true'><path d='M18 6L6 18M6 6l12 12' stroke='currentColor' stroke-width='1.5' stroke-linecap='round'/></svg>`;
var ICON_PLUS = `<svg viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'><path d='M6 2.5v7M2.5 6h7' stroke='currentColor' stroke-width='1.2' stroke-linecap='round'/></svg>`;
var ICON_MINUS = `<svg viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'><path d='M2.5 6h7' stroke='currentColor' stroke-width='1.2' stroke-linecap='round'/></svg>`;

// src/shared/algolia/product-data.ts
var cardIndex = 0;
var formIds = /* @__PURE__ */ new WeakMap();
function formIdFor(hit, variantId) {
  const existing = formIds.get(hit);
  if (existing) return existing;
  const id = `quickBuyForm${hit.id ?? variantId}add-${++cardIndex}`;
  formIds.set(hit, id);
  return id;
}
var DEFAULT_CARD_ASSETS = {
  alertIcon: "",
  notifyMeLabel: "",
  quickBuyIcon: "",
  quickBuyLabel: "",
  setToComposeLabel: "",
  cardActionAriaLabel: "",
  contenanceLabel: "Contenance",
  modelsLabelOne: "+{{ count }} model",
  modelsLabelOther: "+{{ count }} models"
};
var PREFIXED_CURRENCY_SYMBOLS = {
  JPY: "\xA5",
  GBP: "\xA3"
};
function formatPrice(price) {
  if (price == null) return "";
  try {
    const numericPrice = typeof price === "number" ? price : Number(price);
    const currency = window.currencyIsoCode || window.Shopify?.currency?.active || "EUR";
    const amount = new Intl.NumberFormat(
      document.documentElement.lang || "fr-FR",
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }
    ).format(numericPrice);
    const moneyFormat = window.algoliaMoneyFormat;
    if (moneyFormat && moneyFormat.includes("0")) {
      return moneyFormat.replace("0", amount);
    }
    const currencySymbol = new Intl.NumberFormat(document.documentElement.lang || "fr-FR", {
      style: "currency",
      currency,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).formatToParts(0).find((part) => part.type === "currency")?.value ?? currency;
    if (currencySymbol.includes("$")) {
      const currencyPrefix = currency.slice(0, 2);
      return currencyPrefix === "HK" ? `HK$${amount}` : `${currencyPrefix} $${amount}`;
    }
    const prefixedSymbol = PREFIXED_CURRENCY_SYMBOLS[currency];
    if (prefixedSymbol) {
      return `${prefixedSymbol}${amount}`;
    }
    return `${amount} ${currencySymbol}`;
  } catch {
    return String(price);
  }
}
function numericPriceValue(price) {
  if (price == null) return null;
  if (typeof price === "string" && price.trim() === "") return null;
  const numericPrice = typeof price === "number" ? price : Number(price);
  return Number.isFinite(numericPrice) ? numericPrice : null;
}
function parseMediaTags(hit) {
  if (!hit.meta?.custom?.media_tags) return [];
  try {
    return JSON.parse(hit.meta.custom.media_tags);
  } catch {
    return [];
  }
}
var CARD_IMAGE_WIDTH = 600;
var SHOPIFY_CDN_HOSTNAME = /(?:^|\.)(?:shopify|shopifycdn)\.(?:com|net)$/;
function resizedImageUrl(url, width) {
  if (!url) return null;
  try {
    const parsed = new URL(url, window.location.href);
    if (!SHOPIFY_CDN_HOSTNAME.test(parsed.hostname)) return url;
    if (parsed.searchParams.has("width")) return url;
    parsed.searchParams.set("width", String(width));
    return parsed.toString();
  } catch {
    return url;
  }
}
function cardImageUrl(url) {
  return resizedImageUrl(url, CARD_IMAGE_WIDTH);
}
function mediaUrlForTag(hit, tag) {
  const entry = parseMediaTags(hit).find(
    (media) => Array.isArray(media.tags) && media.tags.includes(tag)
  );
  return entry?.src ?? entry?.url ?? entry?.image_url ?? (typeof entry?.image === "string" && entry.image.startsWith("http") ? entry.image : null);
}
function hoverImageUrl(hit) {
  return mediaUrlForTag(hit, "Hover");
}
function plpFirstImageUrl(hit) {
  return mediaUrlForTag(hit, "PLP first visual");
}
function nightImageUrl(hit) {
  return mediaUrlForTag(hit, "Night vision");
}
function countRelatedProducts(value) {
  if (Array.isArray(value)) return value.length;
  if (typeof value === "object" && value !== null && "value" in value) {
    return countRelatedProducts(value.value);
  }
  if (typeof value !== "string") return 0;
  const normalizedValue = value.trim();
  if (!normalizedValue) return 0;
  try {
    return countRelatedProducts(JSON.parse(normalizedValue));
  } catch {
    return normalizedValue.includes(",") ? normalizedValue.split(",").length : 1;
  }
}
var CARD_ACTION_PLACEHOLDER = /ACTION|PRODUCT_NAME/g;
function formatCardActionAriaLabel(action, productName, assets) {
  const template = assets.cardActionAriaLabel?.trim();
  if (!template || !productName) return void 0;
  return template.replace(
    CARD_ACTION_PLACEHOLDER,
    (token) => token === "ACTION" ? action : productName
  );
}
var COUNT_PLACEHOLDER = /\{\{\s*count\s*\}\}|\{count\}/g;
function formatModelsLabel(count, assets) {
  const template = (count === 1 ? assets.modelsLabelOne : assets.modelsLabelOther).trim();
  if (!template) return "";
  COUNT_PLACEHOLDER.lastIndex = 0;
  if (COUNT_PLACEHOLDER.test(template)) {
    COUNT_PLACEHOLDER.lastIndex = 0;
    return template.replace(COUNT_PLACEHOLDER, String(count));
  }
  return `+${count} ${template}`;
}
function otherModelsCount(hit) {
  return countRelatedProducts(
    hit.meta?.custom?.related_products ?? hit.related_products
  ) - 1;
}
function localizedMetaobjectLabel(gid) {
  if (typeof gid !== "string") return "";
  const id = /\/Metaobject\/(\d+)/.exec(gid)?.[1];
  if (!id) return "";
  const label = window.algoliaMetaobjectLabels?.[id];
  return typeof label === "string" ? label.trim() : "";
}
function metaobjectValue(value) {
  if (typeof value === "object" && value !== null) {
    const metaobject = value;
    const localized = localizedMetaobjectLabel(metaobject._id);
    if (localized) return localized;
    const fieldValue = metaobject.fields?.value;
    if (typeof fieldValue === "string") return fieldValue.trim();
  }
  return "";
}
function productTagLabels(tags = []) {
  return tags.map((tag) => localizedMetaobjectLabel(tag._id) || tag.fields?.name).filter((name) => Boolean(name));
}
function productInfoParts(hit) {
  return {
    label: metaobjectValue(hit.meta?.custom?.format) || (hit.meta?.custom?.label ?? ""),
    contenance: metaobjectValue(hit.meta?.custom?.capacity) || (hit.meta?.custom?.contenance ?? "")
  };
}
function isSetToComposeProduct(hit) {
  if (String(hit.template_suffix ?? "").trim() === "set-to-compose") {
    return true;
  }
  const bundle = hit.meta?.bundle;
  if (!bundle) return false;
  const pricingMode = String(bundle.pricing_mode ?? "").trim();
  const bundleSize = Number(bundle.size);
  return Boolean(pricingMode) || Number.isFinite(bundleSize) && bundleSize > 0;
}
function isVirtualSetProduct(hit) {
  return String(hit.meta?.bundle?.pricing_mode ?? "").trim().toLowerCase() === "virtual set";
}
var VARIANT_GID_PATTERN = /\/ProductVariant\/(\d+)/;
function childVariantIdFrom(value) {
  const normalizedValue = nestedValue(value);
  if (typeof normalizedValue === "string") {
    const match = VARIANT_GID_PATTERN.exec(normalizedValue);
    return match ? match[1] : null;
  }
  if (typeof normalizedValue === "object" && normalizedValue !== null) {
    return childVariantIdFrom(
      normalizedValue.variant_id
    );
  }
  return null;
}
function virtualSetChildVariantIds(hit, parentVariantId) {
  if (!isVirtualSetProduct(hit)) return [];
  const parent = String(parentVariantId);
  return allowedProductsFrom(hit.meta?.bundle?.allowed_products).map(childVariantIdFrom).filter(
    (variantId) => variantId !== null && variantId !== parent
  );
}
function virtualSetBundleId(parentVariantId) {
  return `bundle-${parentVariantId}`;
}
function parseBoolean(value) {
  if (typeof value === "boolean") return value;
  if (typeof value !== "string") return null;
  const normalizedValue = value.trim().toLowerCase();
  if (normalizedValue === "true") return true;
  if (normalizedValue === "false") return false;
  return null;
}
function parseJsonValue(value) {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}
function nestedValue(value) {
  if (typeof value === "object" && value !== null && "value" in value) {
    return nestedValue(value.value);
  }
  return value;
}
function allowedProductsFrom(value) {
  const normalizedValue = nestedValue(value);
  if (Array.isArray(normalizedValue)) return normalizedValue;
  if (typeof normalizedValue !== "string") return [];
  const parsedValue = parseJsonValue(normalizedValue.trim());
  return Array.isArray(parsedValue) ? parsedValue : [];
}
function normalizeBundlePrice(value) {
  if (!Number.isFinite(value) || value <= 0) return null;
  return Number.isInteger(value) && value >= 1e3 ? value / 100 : value;
}
function priceFromAllowedProduct(value) {
  const normalizedValue = nestedValue(value);
  if (typeof normalizedValue === "number") {
    return normalizeBundlePrice(normalizedValue);
  }
  if (typeof normalizedValue === "string") {
    const parsedNumber = Number(normalizedValue);
    if (Number.isFinite(parsedNumber)) return normalizeBundlePrice(parsedNumber);
    const parsedValue = parseJsonValue(normalizedValue);
    if (parsedValue !== normalizedValue)
      return priceFromAllowedProduct(parsedValue);
    return null;
  }
  if (typeof normalizedValue !== "object" || normalizedValue === null) {
    return null;
  }
  const product = normalizedValue;
  const directPrice = priceFromAllowedProduct(
    product.price ?? product.variant_price ?? product.selected_or_first_available_variant_price
  );
  if (directPrice != null) return directPrice;
  return priceFromAllowedProduct(
    product.selected_or_first_available_variant?.price ?? product.variant?.price ?? product.product?.selected_or_first_available_variant
  );
}
function dynamicBundleLowestPrice(hit) {
  const bundle = hit.meta?.bundle;
  if (!bundle) return null;
  const pricingMode = String(bundle.pricing_mode ?? "").trim().toLowerCase();
  const bundleSize = Number(bundle.size);
  if (pricingMode !== "dynamic" || !Number.isFinite(bundleSize) || bundleSize <= 0) {
    return null;
  }
  const allowedPrices = allowedProductsFrom(bundle.allowed_products).map(priceFromAllowedProduct).filter((price) => price != null).sort((firstPrice, secondPrice) => firstPrice - secondPrice);
  if (allowedPrices.length === 0) return null;
  const allowDuplicates = parseBoolean(bundle.allow_duplicates);
  if (allowDuplicates === false) {
    const selectedPrices = allowedPrices.slice(0, bundleSize);
    if (selectedPrices.length < bundleSize) return null;
    return selectedPrices.reduce((total, price) => total + price, 0);
  }
  return allowedPrices[0] * bundleSize;
}
function marketPricingKey() {
  const currency = window.Shopify?.currency?.active?.toLowerCase();
  return currency ? `market_pricing_${currency}` : null;
}
function productAttributesToRetrieve(base = ALGOLIA_PRODUCT_ATTRIBUTES_TO_RETRIEVE) {
  const key = marketPricingKey();
  return key ? [...base, key] : base;
}
function getMarketPrice(hit) {
  const key = marketPricingKey();
  const marketPrice = key ? numericPriceValue(
    hit[key]?.price
  ) : null;
  return marketPrice != null && marketPrice > 0 ? marketPrice : hit.price;
}
function renderProductPrice(hit) {
  if (isSetToComposeProduct(hit) && numericPriceValue(hit.price) === 0) {
    return "";
  }
  const bundlePrice = dynamicBundleLowestPrice(hit);
  if (bundlePrice != null) return formatPrice(bundlePrice);
  const price = getMarketPrice(hit);
  return price != 0 ? formatPrice(price) : "";
}
function giftProductIdFromGid(gid) {
  const match = /\/Product\/(\d+)/.exec(gid);
  return match ? match[1] : null;
}
function giftFromHit(hit) {
  const gift = hit.meta?.custom?.gift_product;
  if (!gift) return null;
  if (typeof gift === "string") {
    const productId = giftProductIdFromGid(gift);
    return productId ? { productId } : null;
  }
  if (typeof gift === "object") {
    if (gift.variant_id != null && gift.variant_id !== "") {
      return { variantId: gift.variant_id, available: gift.available !== false };
    }
    const productId = gift.id ? giftProductIdFromGid(gift.id) : null;
    return productId ? { productId } : null;
  }
  return null;
}
function isGiftEligible(hit) {
  return !isSetToComposeProduct(hit) && !Object.is(hit.inventory_available, false);
}
function preorderStrings() {
  const strings = window.variantStrings;
  const btn = strings?.pre_order?.trim() ?? "";
  const property = strings?.pre_order_property?.trim() ?? "";
  const dateFormat = strings?.pre_order_date_format?.trim() ?? "";
  return btn && property ? { btn, dateFormat, property } : null;
}
function formatPreorderDate(isoDate, pattern) {
  const [year, month, day] = isoDate.split("-");
  if (!year || !month || !day || !pattern) return isoDate;
  return pattern.replace(/%[Ymd]/g, (directive) => {
    if (directive === "%Y") return year;
    return directive === "%m" ? month : day;
  });
}
function preorderDateOf(hit) {
  const fields = hit.meta?.custom?.preorder?.fields;
  if (parseBoolean(fields?.active) !== true) return "";
  const date = String(fields?.date ?? "").trim();
  if (!date) return "";
  const now = /* @__PURE__ */ new Date();
  const today = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, "0"),
    String(now.getDate()).padStart(2, "0")
  ].join("-");
  return date > today ? date : "";
}
function preorderButtonLabel(hit) {
  const strings = preorderStrings();
  if (!strings) return "";
  return preorderDateOf(hit) ? strings.btn : "";
}
function contenanceOf(hit) {
  const capacity = metaobjectValue(hit.meta?.custom?.capacity);
  if (capacity) return capacity;
  const custom = hit.meta?.custom?.contenance;
  if (typeof custom === "string" && custom) return custom;
  return typeof hit.contenance === "string" ? hit.contenance : "";
}

// src/shared/algolia/ProductCard.tsx
import { Fragment } from "preact";

// src/shared/algolia/cart-gifts.ts
var handles = /* @__PURE__ */ new Set();
var inFlight = null;
var hydrated = false;
var version = 0;
var listening = false;
function listenForCartChanges() {
  if (listening || typeof document === "undefined") return;
  listening = true;
  document.addEventListener("cart:add-success", () => {
    hydrated = false;
  });
}
function routesRoot() {
  const root = window.Shopify?.routes?.root;
  return root && root.length ? root : "/";
}
async function fetchGiftedHandles() {
  const base = routesRoot().replace(/\/$/, "");
  const response = await fetch(`${base}/cart.js`, {
    credentials: "same-origin",
    headers: { accept: "application/json" }
  });
  if (!response.ok) {
    throw new Error(`cart read failed with status ${response.status}`);
  }
  const cart = await response.json();
  const next = /* @__PURE__ */ new Set();
  for (const item of cart.items ?? []) {
    if (!item?.handle) continue;
    const child = item.properties?._child;
    if (child == null || child === "") continue;
    next.add(item.handle);
  }
  return next;
}
function sameSet(a, b) {
  if (a.size !== b.size) return false;
  for (const value of a) if (!b.has(value)) return false;
  return true;
}
function giftedHandles() {
  return handles;
}
function hasGiftInCart(handle) {
  return handle ? handles.has(handle) : false;
}
function giftedVersion() {
  return version;
}
async function refreshGiftedHandles() {
  listenForCartChanges();
  if (hydrated && !inFlight) return;
  if (!inFlight) {
    inFlight = fetchGiftedHandles().catch((error) => {
      console.warn("[gift-product] cart read failed", error);
      return handles;
    });
  }
  const next = await inFlight;
  inFlight = null;
  hydrated = true;
  if (sameSet(handles, next)) return;
  handles = next;
  version += 1;
}
function invalidateGiftedHandles() {
  hydrated = false;
}

// src/shared/algolia/ProductCard.tsx
import { Fragment as Fragment2, jsx, jsxs } from "preact/jsx-runtime";
function GiftParentProperty({
  giftVariantId
}) {
  return /* @__PURE__ */ jsx(
    "input",
    {
      type: "hidden",
      name: "items[0][properties][_child]",
      value: giftVariantId
    }
  );
}
function GiftLineItemInputs({
  giftVariantId,
  parentVariantId
}) {
  return /* @__PURE__ */ jsxs(Fragment2, { children: [
    /* @__PURE__ */ jsx("input", { type: "hidden", name: "items[1][id]", value: giftVariantId }),
    /* @__PURE__ */ jsx("input", { type: "hidden", name: "items[1][parent_id]", value: parentVariantId }),
    /* @__PURE__ */ jsx("input", { type: "hidden", name: "items[1][quantity]", value: "1" }),
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "hidden",
        name: "items[1][properties][_gift_product]",
        value: "true"
      }
    ),
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "hidden",
        name: "items[1][properties][_parent_id]",
        value: parentVariantId
      }
    )
  ] });
}
function VirtualSetLineItems({
  childVariantIds,
  parentVariantId
}) {
  const bundleId = virtualSetBundleId(parentVariantId);
  return /* @__PURE__ */ jsx(Fragment2, { children: childVariantIds.map((childVariantId, index) => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "hidden",
        name: `items[${index}][id]`,
        value: childVariantId
      }
    ),
    /* @__PURE__ */ jsx("input", { type: "hidden", name: `items[${index}][quantity]`, value: "1" }),
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "hidden",
        name: `items[${index}][properties][_bundle_id]`,
        value: bundleId
      }
    ),
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "hidden",
        name: `items[${index}][properties][_bundle_role]`,
        value: "child"
      }
    ),
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "hidden",
        name: `items[${index}][properties][_bundle_parent_variant]`,
        value: `gid://shopify/ProductVariant/${parentVariantId}`
      }
    )
  ] }, `${index}-${childVariantId}`)) });
}
function AddToCartInputs({
  contenanceLabel,
  hit,
  resolvedGift,
  variantId
}) {
  const virtualSetChildren = virtualSetChildVariantIds(hit, variantId);
  if (virtualSetChildren.length > 0) {
    return /* @__PURE__ */ jsx(
      VirtualSetLineItems,
      {
        childVariantIds: virtualSetChildren,
        parentVariantId: variantId
      }
    );
  }
  const contenance = contenanceOf(hit);
  const preorder = preorderStrings();
  const preorderDate = preorder ? preorderDateOf(hit) : "";
  const gift = isGiftEligible(hit) ? giftFromHit(hit) : null;
  const inlineGift = gift && "variantId" in gift && gift.available ? { variantId: gift.variantId } : null;
  const giftLine = inlineGift ?? resolvedGift ?? null;
  const alreadyGifted = hasGiftInCart(hit.handle);
  return /* @__PURE__ */ jsxs(Fragment2, { children: [
    /* @__PURE__ */ jsx("input", { type: "hidden", name: "items[0][id]", value: variantId }),
    /* @__PURE__ */ jsx("input", { type: "hidden", name: "items[0][quantity]", value: "1" }),
    giftLine ? /* @__PURE__ */ jsx(GiftParentProperty, { giftVariantId: giftLine.variantId }) : null,
    contenance ? /* @__PURE__ */ jsx(
      "input",
      {
        type: "hidden",
        name: `items[0][properties][${contenanceLabel}]`,
        value: contenance
      }
    ) : null,
    preorder && preorderDate ? /* @__PURE__ */ jsx(
      "input",
      {
        type: "hidden",
        name: `items[0][properties][${preorder.property}]`,
        value: formatPreorderDate(preorderDate, preorder.dateFormat)
      }
    ) : null,
    giftLine && !alreadyGifted ? /* @__PURE__ */ jsx(
      GiftLineItemInputs,
      {
        giftVariantId: giftLine.variantId,
        parentVariantId: variantId
      }
    ) : null
  ] });
}
function QuickBuyContent({ icon, label }) {
  return /* @__PURE__ */ jsxs("span", { class: "card-product-quick-buy__content", children: [
    /* @__PURE__ */ jsx(
      "span",
      {
        class: "logo",
        "aria-hidden": "true",
        dangerouslySetInnerHTML: { __html: icon }
      }
    ),
    /* @__PURE__ */ jsx("span", { class: "label label-s-regular", children: label })
  ] });
}
function QuickBuyButton({
  assets,
  formId,
  giftPending,
  hit,
  url,
  variantId
}) {
  const available = !Object.is(hit.inventory_available, false);
  if (!available) {
    const notifyUrl = url.includes("#notify-me") ? url : `${url}#notify-me`;
    return /* @__PURE__ */ jsx(
      "a",
      {
        class: "card-product-quick-buy",
        "aria-label": formatCardActionAriaLabel(
          assets.notifyMeLabel,
          hit.title,
          assets
        ),
        "data-notify-me-button": true,
        href: notifyUrl,
        children: /* @__PURE__ */ jsx(QuickBuyContent, { icon: assets.alertIcon, label: assets.notifyMeLabel })
      }
    );
  }
  if (isSetToComposeProduct(hit) && virtualSetChildVariantIds(hit, variantId).length === 0) {
    return /* @__PURE__ */ jsx(
      "a",
      {
        class: "card-product-quick-buy",
        "aria-label": formatCardActionAriaLabel(
          assets.setToComposeLabel,
          hit.title,
          assets
        ),
        href: url,
        children: /* @__PURE__ */ jsx(
          QuickBuyContent,
          {
            icon: assets.quickBuyIcon,
            label: assets.setToComposeLabel
          }
        )
      }
    );
  }
  const preorderLabel = preorderButtonLabel(hit);
  const label = preorderLabel || assets.quickBuyLabel;
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: "submit",
      form: formId,
      class: "card-product-quick-buy",
      "aria-label": formatCardActionAriaLabel(label, hit.title, assets),
      "data-algolia-convert": true,
      disabled: giftPending,
      "aria-busy": giftPending ? "true" : void 0,
      "data-gift-pending": giftPending ? "" : void 0,
      children: /* @__PURE__ */ jsx(QuickBuyContent, { icon: assets.quickBuyIcon, label })
    }
  );
}
function QuickBuy({
  assets,
  hit,
  resolvedGift,
  url
}) {
  const variantId = hit.variant_id ?? hit.objectID ?? "";
  const formId = formIdFor(hit, variantId);
  const gift = isGiftEligible(hit) ? giftFromHit(hit) : null;
  const needsGiftResolution = Boolean(gift && "productId" in gift && hit.handle);
  const giftPending = Boolean(needsGiftResolution && resolvedGift === void 0);
  return /* @__PURE__ */ jsx("c-product-form", { "data-action": "add", class: "card-product-quick-buy__container", children: /* @__PURE__ */ jsxs(
    "form",
    {
      id: formId,
      class: "form",
      action: "/cart/add",
      method: "post",
      novalidate: true,
      "data-type": "add-to-cart-form",
      ...needsGiftResolution ? {
        "data-gift-parent-handle": hit.handle,
        "data-gift-parent-id": String(variantId)
      } : {},
      children: [
        /* @__PURE__ */ jsx("input", { type: "hidden", value: "header,popup-add-to-cart", name: "sections" }),
        /* @__PURE__ */ jsx(
          AddToCartInputs,
          {
            contenanceLabel: assets.contenanceLabel,
            hit,
            resolvedGift,
            variantId
          }
        ),
        /* @__PURE__ */ jsx("div", { class: "card-product-quick-buy__wrapper--content", children: /* @__PURE__ */ jsx(
          QuickBuyButton,
          {
            assets,
            formId,
            giftPending,
            hit,
            url,
            variantId
          }
        ) }),
        /* @__PURE__ */ jsx(
          "div",
          {
            class: "product-form__error",
            "data-product-form-error": true,
            style: { display: "none" }
          }
        )
      ]
    }
  ) });
}
var EAGER_CARD_COUNT = 4;
function ProductImage({
  hoverUrl,
  mainUrl,
  nightUrl,
  priority = false
}) {
  return /* @__PURE__ */ jsxs(Fragment2, { children: [
    /* @__PURE__ */ jsx("figure", { "data-night-src": nightUrl || void 0, children: mainUrl ? /* @__PURE__ */ jsx(
      "img",
      {
        src: mainUrl,
        alt: "",
        loading: priority ? "eager" : "lazy",
        fetchpriority: priority ? "high" : void 0,
        decoding: "async",
        width: "600",
        height: "800"
      }
    ) : null }),
    hoverUrl ? /* @__PURE__ */ jsx("figure", { children: /* @__PURE__ */ jsx(
      "img",
      {
        src: hoverUrl,
        alt: "",
        loading: "lazy",
        fetchpriority: "low",
        decoding: "async",
        width: "600",
        height: "800"
      }
    ) }) : null
  ] });
}
function AddonTags({ tags = [] }) {
  const labels = productTagLabels(tags);
  if (labels.length === 0) return null;
  return /* @__PURE__ */ jsx("div", { class: "card-product_tags", children: labels.map((name) => /* @__PURE__ */ jsx("span", { class: "tag label-s-regular", children: name }, name)) });
}
function ProductInfo({
  assets,
  hit
}) {
  const { contenance, label } = productInfoParts(hit);
  const models = otherModelsCount(hit);
  const modelsLabel = models > 0 ? formatModelsLabel(models, assets) : "";
  if (!label && !contenance && !modelsLabel) {
    return /* @__PURE__ */ jsx("div", { class: "card-product__meta" });
  }
  const parts = [
    label ? /* @__PURE__ */ jsx("span", { class: "label-s-regular", children: label }, "label") : null,
    label && contenance ? /* @__PURE__ */ jsx("span", { class: "label-s-regular", children: "-" }, "separator") : null,
    contenance ? /* @__PURE__ */ jsx("span", { class: "label-s-regular", children: contenance }, "contenance") : null,
    modelsLabel ? /* @__PURE__ */ jsx("span", { class: "label-s-regular color-secondary", children: modelsLabel }, "models") : null
  ].filter((part) => part !== null);
  return /* @__PURE__ */ jsx("div", { class: "card-product__meta", children: parts.map((part, index) => index === 0 ? part : [" ", part]) });
}
function ProductCard({
  assets = DEFAULT_CARD_ASSETS,
  hit,
  rank,
  resolvedGift
}) {
  const url = itemUrl(hit);
  const price = renderProductPrice(hit);
  const subtitle = hit.meta?.custom?.subtitle ?? hit.subtitle ?? "";
  const plpFirstUrl = assets.plpFirstVisual ? cardImageUrl(plpFirstImageUrl(hit)) : null;
  const mainUrl = plpFirstUrl ?? cardImageUrl(hit.image);
  const taggedHoverUrl = cardImageUrl(hoverImageUrl(hit));
  const hoverUrl = taggedHoverUrl;
  const hasHover = Boolean(hoverUrl);
  const nightUrl = cardImageUrl(nightImageUrl(hit));
  return (
    // `objectID` is a variant id, and Insights events carrying anything else are
    // dropped by the models — so the card states it rather than letting the
    // listener guess from the cart payload. Read by
    // src/shared/insights/algolia-insights.ts.
    /* @__PURE__ */ jsxs(
      "article",
      {
        class: "card-product",
        "data-algolia-object-id": String(hit.objectID ?? hit.variant_id ?? ""),
        "data-algolia-product-id": String(hit.id ?? ""),
        children: [
          /* @__PURE__ */ jsxs("div", { class: "card-product__top", children: [
            /* @__PURE__ */ jsx("div", { class: `card-product_image${hasHover ? " is-hover-active" : ""}`, children: /* @__PURE__ */ jsx(
              ProductImage,
              {
                hoverUrl,
                mainUrl,
                nightUrl,
                priority: rank !== void 0 && rank < EAGER_CARD_COUNT
              }
            ) }),
            /* @__PURE__ */ jsx(AddonTags, { tags: hit.meta?.custom?.product_tags })
          ] }),
          /* @__PURE__ */ jsx("div", { class: "card-product_content", children: /* @__PURE__ */ jsxs("div", { class: "card-product_infos", children: [
            /* @__PURE__ */ jsxs("div", { class: "card-product_infos_top", children: [
              /* @__PURE__ */ jsx("h3", { class: "card-product__title label-m-alternate", children: /* @__PURE__ */ jsx(
                "a",
                {
                  class: "card-product__stretched-link",
                  href: url,
                  "data-algolia-click": true,
                  children: hit.title
                }
              ) }),
              /* @__PURE__ */ jsx("div", { class: "card-product__description card-product_description body-m-light color-secondary", children: subtitle })
            ] }),
            /* @__PURE__ */ jsxs("div", { class: "card-product_infos_bottom", children: [
              /* @__PURE__ */ jsx(ProductInfo, { assets, hit }),
              /* @__PURE__ */ jsx("span", { class: "card-product__price label-m-regular", children: price })
            ] })
          ] }) }),
          /* @__PURE__ */ jsx(
            QuickBuy,
            {
              assets,
              hit,
              resolvedGift,
              url
            }
          )
        ]
      }
    )
  );
}

// src/shared/algolia/render-cards.tsx
import { render } from "preact";
import { Fragment as Fragment3, jsx as jsx2 } from "preact/jsx-runtime";
var owned = /* @__PURE__ */ new WeakSet();
function renderCards(container, { assets, gifts, hits, slideClass }) {
  if (!container) return;
  if (!owned.has(container)) {
    owned.add(container);
    container.replaceChildren();
  }
  const cards = hits.map((hit, index) => {
    const key = String(hit.objectID ?? index);
    const card = /* @__PURE__ */ jsx2(
      ProductCard,
      {
        assets,
        hit,
        resolvedGift: hit.handle ? gifts?.get(hit.handle) : null
      }
    );
    if (slideClass) {
      return /* @__PURE__ */ jsx2("li", { class: slideClass, children: /* @__PURE__ */ jsx2("c-product-card", { children: card }) }, key);
    }
    return /* @__PURE__ */ jsx2("li", { children: card }, key);
  });
  render(/* @__PURE__ */ jsx2(Fragment3, { children: cards }), container);
}

// src/shared/algolia/gift-hydrate.ts
var GIFT_SECTION_ID = "gift-product-data";
var giftCache = /* @__PURE__ */ new Map();
function routesRoot2() {
  const root = window.Shopify?.routes?.root;
  return root && root.length ? root : "/";
}
async function fetchGiftForHandle(handle) {
  const base = routesRoot2().replace(/\/$/, "");
  const url = `${base}/products/${encodeURIComponent(handle)}?section_id=${GIFT_SECTION_ID}`;
  const response = await fetch(url, { credentials: "same-origin" });
  if (!response.ok) {
    throw new Error(`gift section render failed with status ${response.status}`);
  }
  const html = await response.text();
  const json = new DOMParser().parseFromString(html, "text/html").querySelector("[data-gift-product-json]")?.textContent;
  if (!json) return null;
  const data = JSON.parse(json);
  const variantId = data.variant_id == null || data.variant_id === "" ? "" : String(data.variant_id);
  if (!variantId || data.available === false) return null;
  return { variantId, available: true };
}
function resolveGift(handle) {
  let cached = giftCache.get(handle);
  if (!cached) {
    cached = fetchGiftForHandle(handle).catch((error) => {
      console.warn("[gift-product] resolution failed", handle, error);
      return null;
    });
    giftCache.set(handle, cached);
  }
  return cached;
}
function handlesNeedingResolution(hits) {
  const handles2 = /* @__PURE__ */ new Set();
  for (const hit of hits) {
    if (!hit.handle || !isGiftEligible(hit)) continue;
    const gift = giftFromHit(hit);
    if (gift && "productId" in gift) handles2.add(hit.handle);
  }
  return handles2;
}
async function resolveGiftsForHits(hits, known) {
  const missing = Array.from(handlesNeedingResolution(hits)).filter(
    (handle) => !known?.has(handle)
  );
  if (missing.length === 0) return null;
  const entries = await Promise.all(
    missing.map(async (handle) => {
      const resolved = await resolveGift(handle);
      return [
        handle,
        resolved ? { variantId: resolved.variantId } : null
      ];
    })
  );
  return new Map([...known ?? [], ...entries]);
}

// src/shared/algolia-rule-push/algolia-rule-push.ts
function isRecord(value) {
  return value !== null && typeof value === "object";
}
function asString(value) {
  return typeof value === "string" ? value.trim() : "";
}
function parseUserDataItem(item) {
  if (typeof item !== "string") return item;
  try {
    return JSON.parse(item);
  } catch {
    return item;
  }
}
function normalizeUserData(userData) {
  const parsedUserData = parseUserDataItem(userData);
  if (Array.isArray(parsedUserData)) {
    return parsedUserData.flatMap(normalizeUserData);
  }
  if (!isRecord(parsedUserData)) return [];
  const list = parsedUserData;
  const nestedList = [list.push, list.pushes, list.items, list.rules].find(
    Array.isArray
  );
  if (nestedList) return normalizeUserData(nestedList);
  return [parsedUserData];
}
function normalizeOrder(value) {
  const order = typeof value === "number" ? value : Number(value);
  if (!Number.isInteger(order) || order < 1) return null;
  return order;
}
function normalizeStyle(value, fallback) {
  return value || fallback;
}
function normalizeButtonType(item) {
  return normalizeStyle(
    asString(item.button?.button_type) || asString(item.button?.button_style),
    "v-primary"
  );
}
function normalizeButtonSize(item) {
  return normalizeStyle(asString(item.button?.button_size), "v-large");
}
function normalizeButtonVariant(item) {
  return normalizeStyle(asString(item.button?.button_variant), "v-dark");
}
function renderBulletIcon() {
  return `<svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' viewBox='0 0 17 16' fill='none' aria-hidden='true'>
    <path d='M9.5 8C9.5 8.55228 9.05228 9 8.5 9C7.94772 9 7.5 8.55228 7.5 8C7.5 7.44772 7.94772 7 8.5 7C9.05228 7 9.5 7.44772 9.5 8Z' fill='currentColor'/>
  </svg>`;
}
function renderCta(label, url, type, size, variant) {
  return `<a class='cta v-margin-top ${escapeHtml(type)} ${escapeHtml(size)} ${escapeHtml(variant)} v-fit' href='${url}' target='_self' rel='_self'>
    <span class='cta--label'>
      ${renderBulletIcon()}
      <span class='cta--label__text'>${escapeHtml(label)}</span>
      ${renderBulletIcon()}
    </span>
  </a>`;
}
function renderLink(label, url, type) {
  return `<a class='link ${escapeHtml(type)}' href='${url}'>
    <span class='cta--label'>
      <span class='cta--label__text'>${escapeHtml(label)}</span>
    </span>
  </a>`;
}
function normalizeRulePush(item) {
  const buttonUrl = normalizeUrl(asString(item.button?.button_url));
  const linkUrl = normalizeUrl(asString(item.link?.link_url));
  const visualLink = normalizeUrl(asString(item.visualLink));
  const ctaLink = normalizeUrl(asString(item.ctaLinkLink));
  return {
    buttonLabel: asString(item.button?.button_label) || asString(item.ctaLinkText) || "D\xE9couvrir",
    buttonSize: normalizeButtonSize(item),
    buttonType: normalizeButtonType(item),
    buttonUrl: buttonUrl || ctaLink || linkUrl || visualLink || "#",
    buttonVariant: normalizeButtonVariant(item),
    columns: "",
    description: asString(item.content?.description) || asString(item.descr) || asString(item.description),
    imageAlt: "",
    imageDesktop: asString(item.media?.media_desktop) || asString(item.visual?.url) || asString(item.visualDesktop),
    imageMobile: asString(item.media?.media_mobile),
    video: "",
    linkLabel: asString(item.link?.link_label),
    linkStyle: normalizeStyle(asString(item.link?.link_style), "v-primary"),
    linkUrl: linkUrl || buttonUrl || ctaLink || visualLink || "#",
    order: normalizeOrder(item.order),
    ratioDesktop: asString(item.media?.ratio_desktop),
    ratioMobile: asString(item.media?.ratio_mobile),
    sectionHeading: asString(item.sectionHeading),
    title: asString(item.content?.title) || asString(item.heading) || asString(item.title)
  };
}
function getRulePushes(userData) {
  return normalizeUserData(userData).map(normalizeRulePush).filter(
    (item) => item.title || item.description || item.imageDesktop || item.buttonUrl !== "#" || item.linkUrl !== "#"
  ).sort(
    (a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER)
  );
}
function renderRulePush(push, options = {}) {
  const title = escapeHtml(push.title);
  const imageDesktop = escapeHtml(push.imageDesktop);
  const imageMobile = escapeHtml(push.imageMobile || push.imageDesktop);
  const buttonUrl = escapeHtml(push.buttonUrl);
  const linkUrl = escapeHtml(push.linkUrl);
  const ratioStyles = [
    push.ratioDesktop ? `--ratio-desktop: ${escapeHtml(push.ratioDesktop)}` : "",
    push.ratioMobile ? `--ratio-mobile: ${escapeHtml(push.ratioMobile)}` : ""
  ].filter(Boolean).join("; ");
  const styleAttr = ratioStyles ? ` style='${ratioStyles}'` : "";
  const mediaAlt = escapeHtml(push.imageAlt || push.title);
  const mediaInner = push.video ? `<video
          src='${escapeHtml(push.video)}'
          poster='${imageDesktop}'
          autoplay
          muted
          loop
          playsinline
          preload='metadata'
          aria-label='${mediaAlt}'
        ></video>` : `<picture>
          ${imageMobile ? `<source media='(max-width: 767px)' srcset='${imageMobile}'>` : ""}
          <img src='${imageDesktop}' alt='' loading='lazy'>
        </picture>`;
  const mediaHtml = imageDesktop ? `<a aria-label='${mediaAlt}' href='${buttonUrl}' class='algolia-rule-push__media'${styleAttr}>
        ${mediaInner}
      </a>` : "";
  const buttonHtml = push.buttonLabel ? renderCta(
    push.buttonLabel,
    buttonUrl,
    push.buttonType,
    push.buttonSize,
    push.buttonVariant
  ) : "";
  const linkHtml = push.linkLabel ? renderLink(push.linkLabel, linkUrl, push.linkStyle) : "";
  const topHtml = [
    push.sectionHeading && !options.hideSectionHeading ? `<span class='label-s-regular color-secondary'>${escapeHtml(push.sectionHeading)}</span>` : "",
    push.title ? `<h3 class='label-m-alternate'>${title}</h3>` : "",
    push.description ? `<div class='body-m-light color-secondary description'>${escapeHtml(push.description)}</div>` : ""
  ].filter(Boolean).join("");
  const columns = Number(push.columns);
  const rootStyle = Number.isInteger(columns) && columns > 1 ? ` style='--push-columns: ${columns}'` : "";
  return `<c-media-card class='media-card algolia-rule-push'${rootStyle}>
    <div class='media-container'>
      ${mediaHtml}
    </div>
    <div class='content-container'>
      <div class='inside'>
        ${topHtml ? `<div class='inside__top'>${topHtml}</div>` : ""}
        <div class='inside__bottom'>
          ${buttonHtml}
          ${linkHtml}
        </div>
      </div>
    </div>
  </c-media-card>`;
}
function renderRulePushIconic(push, { idPrefix }) {
  const titleId = `${idPrefix}-title`;
  const ctaId = `${idPrefix}-cta`;
  const title = escapeHtml(push.title);
  const url = escapeHtml(push.buttonUrl !== "#" ? push.buttonUrl : push.linkUrl);
  const label = push.linkLabel || push.buttonLabel;
  const imageDesktop = escapeHtml(push.imageDesktop);
  const imageMobile = escapeHtml(push.imageMobile);
  const mediaAlt = escapeHtml(push.imageAlt || push.title);
  const mediaInner = push.video ? `<video
            src='${escapeHtml(push.video)}'
            poster='${imageDesktop}'
            autoplay
            muted
            loop
            playsinline
            preload='metadata'
            aria-label='${mediaAlt}'
          ></video>` : `<picture>
            ${imageMobile ? `<source media='(max-width: 767px)' srcset='${imageMobile}'>` : ""}
            <img src='${imageDesktop}' alt='' loading='lazy'>
          </picture>`;
  const mediaNameAttr = push.title ? `aria-labelledby='${titleId}'` : label ? `aria-labelledby='${ctaId}'` : `aria-label='${mediaAlt}'`;
  const mediaHtml = imageDesktop ? `<a ${mediaNameAttr} href='${url}'>
        <span>
          ${mediaInner}
        </span>
      </a>` : "";
  const ctaLabelledBy = push.title ? `${ctaId} ${titleId}` : ctaId;
  return `<div class='block-push-iconics__push'>
    ${mediaHtml}
    <div class='push__text'>
      ${push.title ? `<span id='${titleId}' class='label-s-alternate'>${title}</span>` : ""}
      ${push.description ? `<span class='body-s-light color-secondary'>${escapeHtml(push.description)}</span>` : ""}
      ${label ? `<a aria-labelledby='${ctaLabelledBy}' class='push__link label-s-regular button-primary--link m-0 w-fit' href='${url}'>
        <span id='${ctaId}' class='button__label'>${escapeHtml(label)}</span>
      </a>` : ""}
    </div>
  </div>`;
}
function renderRulePushIconics(userData, idPrefix = "algolia-push-rule") {
  return getRulePushes(userData).map(
    (push, index) => renderRulePushIconic(push, { idPrefix: `${idPrefix}-${index}` })
  ).join("");
}
function orderRulePushSlots(pushes, productCount, startIndex = 0) {
  const items = [];
  for (let productIndex = 0; productIndex < productCount; productIndex += 1) {
    items.push({
      slot: { kind: "product", productIndex },
      sortIndex: startIndex + productIndex + 1
    });
  }
  pushes.forEach((push, pushIndex) => {
    const pushOrder = push.order;
    if (!pushOrder) return;
    const previousPushesCount = pushes.slice(0, pushIndex).filter(
      (previousPush) => previousPush.order && previousPush.order < pushOrder
    ).length;
    items.push({
      slot: { kind: "push", push },
      sortIndex: pushOrder - previousPushesCount - 0.5
    });
  });
  return items.sort((a, b) => a.sortIndex - b.sortIndex).map((item) => item.slot);
}

// src/shared/shopify/storefront-client.ts
var CDN_STOREFRONT_CLIENT = "https://cdn.jsdelivr.net/npm/@shopify/storefront-api-client@1.0.10/dist/umd/storefront-api-client.min.js";
var SRI_STOREFRONT_CLIENT = "sha384-Umaszdusk0jmZXktuFo3EEfnuPcXw58qIJtk7oD7V/Hvts3WON57o7aFgS/tpc1w";
function readStorefrontConfig(el) {
  const {
    storefrontApiVersion = "",
    storefrontDomain = "",
    storefrontToken = ""
  } = el.dataset;
  if (!storefrontApiVersion || !storefrontDomain || !storefrontToken) {
    return null;
  }
  return {
    apiVersion: storefrontApiVersion,
    publicAccessToken: storefrontToken,
    storeDomain: storefrontDomain
  };
}
var clients = /* @__PURE__ */ new Map();
function clientKey(config) {
  return `${config.storeDomain}|${config.apiVersion}|${config.publicAccessToken}`;
}
function languageCode() {
  const lang = document.documentElement.lang.trim().replace("-", "_").toUpperCase();
  return lang || null;
}
function countryCode() {
  const country = window.Shopify?.country;
  return country?.trim().toUpperCase() || null;
}
function getStorefrontClient(config) {
  const key = clientKey(config);
  const cached = clients.get(key);
  if (cached) return cached;
  const promise = (async () => {
    try {
      await loadScript(CDN_STOREFRONT_CLIENT, SRI_STOREFRONT_CLIENT);
      const module = window.ShopifyStorefrontAPIClient;
      if (!module) return null;
      return module.createStorefrontApiClient({
        apiVersion: config.apiVersion,
        publicAccessToken: config.publicAccessToken,
        // 429/503 only — the client never retries a 4xx auth failure.
        retries: 1,
        storeDomain: config.storeDomain
      });
    } catch {
      return null;
    }
  })();
  clients.set(key, promise);
  return promise;
}
var REFERENCE_FRAGMENT = `
    ... on MediaImage { image { url altText width height } }
    ... on Video {
      alt
      previewImage { url width height }
      sources { url mimeType format width height }
    }
    ... on GenericFile { url alt previewImage { url width height } }
    ... on Product { __typename handle }
    ... on Collection { __typename handle }
    ... on Page { __typename handle }`;
function metaobjectFragment(depth) {
  const nested = depth > 1 ? metaobjectFragment(depth - 1) : "";
  return `
    ... on Metaobject {
      handle
      type
      fields {
        key
        value
        reference {${REFERENCE_FRAGMENT}${nested}
        }
      }
    }`;
}
var NESTED_METAOBJECT_FRAGMENT = metaobjectFragment(2);
var METAOBJECT_QUERY = `#graphql
  query ThemeMetaobject($type: String!, $handle: String!, $references: Int!, $country: CountryCode, $language: LanguageCode)
  @inContext(country: $country, language: $language) {
    metaobject(handle: { type: $type, handle: $handle }) {
      handle
      type
      fields {
        key
        value
        reference {${REFERENCE_FRAGMENT}${NESTED_METAOBJECT_FRAGMENT}
        }
        references(first: $references) {
          nodes {${NESTED_METAOBJECT_FRAGMENT}
          }
        }
      }
    }
  }`;
function normalizeImage(image) {
  if (!image?.url) return null;
  return {
    altText: image.altText ?? "",
    height: typeof image.height === "number" ? image.height : null,
    url: image.url,
    width: typeof image.width === "number" ? image.width : null
  };
}
function normalizeMedia(ref) {
  if (!ref) return null;
  const still = normalizeImage(ref.image ?? ref.previewImage);
  if (!still) return null;
  const sources = ref.sources ?? [];
  const mp4 = sources.filter(
    (source) => typeof source.url === "string" && source.mimeType === "video/mp4"
  ).map((source) => ({
    height: typeof source.height === "number" ? source.height : null,
    mimeType: "video/mp4",
    url: source.url,
    width: typeof source.width === "number" ? source.width : null
  }));
  const video = mp4[0] ?? sources[0];
  return {
    ...still,
    altText: still.altText || ref.alt || "",
    videoSources: mp4,
    videoUrl: video?.url ?? ""
  };
}
var LINKABLE = ["Product", "Collection", "Page"];
function normalizeResource(ref) {
  const typename = ref?.__typename;
  if (!ref?.handle || !typename) return null;
  if (!LINKABLE.includes(typename))
    return null;
  return {
    handle: ref.handle,
    typename
  };
}
function nestedMetaobject(ref) {
  if (!ref?.type || !Array.isArray(ref.fields)) return null;
  return normalizeMetaobject({
    fields: ref.fields,
    handle: ref.handle,
    type: ref.type
  });
}
function normalizeMetaobject(raw) {
  if (!raw) return null;
  return {
    fields: (raw.fields ?? []).map((field) => ({
      key: field.key ?? "",
      media: normalizeMedia(field.reference),
      metaobject: nestedMetaobject(field.reference),
      references: (field.references?.nodes ?? []).map(normalizeMetaobject).filter((node) => node !== null),
      resource: normalizeResource(field.reference),
      value: field.value ?? ""
    })),
    handle: raw.handle ?? "",
    type: raw.type ?? ""
  };
}
var metaobjects = /* @__PURE__ */ new Map();
function fetchMetaobject(config, {
  handle,
  references = 20,
  type
}) {
  if (!handle || !type) return Promise.resolve(null);
  const country = countryCode();
  const language = languageCode();
  const key = `${clientKey(config)}|${country}|${language}|${type}|${handle}|${references}`;
  const cached = metaobjects.get(key);
  if (cached) return cached;
  const promise = (async () => {
    const client = await getStorefrontClient(config);
    if (!client) return null;
    try {
      const { data, errors } = await client.request(METAOBJECT_QUERY, {
        variables: { country, handle, language, references, type }
      });
      if (errors || !data?.metaobject) return null;
      return normalizeMetaobject(data.metaobject);
    } catch {
      return null;
    }
  })();
  metaobjects.set(key, promise);
  return promise;
}
function metaobjectField(metaobject, key) {
  return metaobject?.fields.find((field) => field.key === key);
}

// src/shared/algolia-rule-push/metaobject-fields.ts
function textOf(entry, key) {
  return metaobjectField(entry, key)?.value ?? "";
}
function numberOf(entry, key) {
  const parsed = Number(textOf(entry, key));
  return Number.isFinite(parsed) ? Math.trunc(parsed) : 0;
}
function booleanOf(entry, key) {
  return textOf(entry, key) === "true";
}
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
function plainValue(raw) {
  if (!raw) return "";
  if (raw.startsWith("{")) {
    try {
      const parsed = JSON.parse(raw);
      const url = parsed && typeof parsed === "object" ? parsed.url : null;
      return typeof url === "string" ? normalizeUrl(url) : "";
    } catch {
      return "";
    }
  }
  return normalizeUrl(raw);
}
function cascadeUrl(entry, prefix, plainKey = prefix) {
  let resolved = "";
  for (const suffix of ["_collection", "_page", "_product"]) {
    const url = resourceUrl(
      metaobjectField(entry, `${prefix}${suffix}`)?.resource
    );
    if (url) resolved = url;
  }
  const plain = plainValue(textOf(entry, plainKey));
  if (plain) resolved = plain;
  return resolved;
}

// src/shared/algolia-rule-push/placed-push.ts
var FIELD_MEDIA_CONTENT = "media_content";
var FIELD_INTERNAL_NAME = "internal_name";
var FIELD_TITLE = "title";
var FIELD_DESCRIPTION = "description";
var FIELD_LINK_LABEL = "link_label";
var FIELD_BUTTON_LABEL = "button_label";
var FIELD_BUTTON_FILE_URL = "button_shopify_file_url";
var FIELD_NEW_TAB = "is_new_tab";
var FIELD_MEDIA_DESKTOP = "media_desktop";
var FIELD_MEDIA_MOBILE = "media_mobile";
function toPlacedPush(entry) {
  const media = metaobjectField(entry, FIELD_MEDIA_CONTENT)?.metaobject ?? null;
  if (!media) return null;
  const desktop = metaobjectField(media, FIELD_MEDIA_DESKTOP)?.media ?? null;
  const mobile = metaobjectField(media, FIELD_MEDIA_MOBILE)?.media ?? desktop;
  if (!desktop && !mobile) return null;
  const title = textOf(entry, FIELD_TITLE);
  const buttonUrl = plainValue(textOf(media, FIELD_BUTTON_FILE_URL)) || cascadeUrl(media, "bouton_url", "button_url");
  return {
    buttonLabel: textOf(media, FIELD_BUTTON_LABEL),
    buttonNewTab: booleanOf(media, FIELD_NEW_TAB),
    buttonUrl,
    columnDesktop: numberOf(entry, "column_desktop"),
    columnMobile: numberOf(entry, "column_mobile"),
    description: textOf(entry, FIELD_DESCRIPTION),
    handle: entry.handle,
    // Nom accessible du visuel : l'alt du fichier, puis le nom interne du push,
    // puis son titre — l'ordre de `push-collection.liquid`, qui n'est pas celui
    // des pushes de Query Rule.
    imageAlt: desktop?.altText || textOf(entry, FIELD_INTERNAL_NAME) || title,
    imageDesktop: desktop?.url ?? "",
    imageMobile: mobile?.url ?? "",
    linkLabel: textOf(entry, FIELD_LINK_LABEL),
    linkUrl: cascadeUrl(entry, "link_url"),
    positionDesktop: numberOf(entry, "position_desktop"),
    positionMobile: numberOf(entry, "position_mobile"),
    ratioDesktop: textOf(entry, "ratio_desktop"),
    ratioMobile: textOf(entry, "ratio_mobile"),
    title,
    videoDesktop: desktop?.videoUrl ?? "",
    videoMobile: mobile?.videoUrl ?? "",
    visualUrl: cascadeUrl(media, "visual_url")
  };
}
function placePush(push) {
  const spanMobile = clamp(push.columnMobile, 1, 2);
  const spanDesktop = clamp(push.columnDesktop, 1, 4);
  const cellMobile = Math.max(push.positionMobile, 1) - 1;
  const cellDesktop = Math.max(push.positionDesktop, 1) - 1;
  return {
    colDesktop: Math.min(cellDesktop % 4 + 1, 5 - spanDesktop),
    colMobile: Math.min(cellMobile % 2 + 1, 3 - spanMobile),
    rowDesktop: Math.floor(cellDesktop / 4) + 1,
    rowMobile: Math.floor(cellMobile / 2) + 1,
    spanDesktop,
    spanMobile
  };
}

// src/shared/shopify/rich-text.ts
function isNode(value) {
  return value !== null && typeof value === "object";
}
function renderChildren(children) {
  if (!Array.isArray(children)) return "";
  return children.map(renderNode).join("");
}
function renderNode(node) {
  if (!isNode(node)) return "";
  switch (node.type) {
    case "text": {
      let html = escapeHtml(node.value ?? "");
      if (!html) return "";
      if (node.italic) html = `<em>${html}</em>`;
      if (node.bold) html = `<strong>${html}</strong>`;
      return html;
    }
    case "link": {
      const attrs = [
        `href="${escapeHtml(node.url ?? "")}"`,
        node.title ? `title="${escapeHtml(node.title)}"` : "",
        node.target ? `target="${escapeHtml(node.target)}"` : ""
      ].filter(Boolean).join(" ");
      return `<a ${attrs}>${renderChildren(node.children)}</a>`;
    }
    case "heading": {
      const level = Math.min(Math.max(Number(node.level) || 1, 1), 6);
      return `<h${level}>${renderChildren(node.children)}</h${level}>`;
    }
    case "paragraph":
      return `<p>${renderChildren(node.children)}</p>`;
    case "list": {
      const tag = node.listType === "ordered" ? "ol" : "ul";
      return `<${tag}>${renderChildren(node.children)}</${tag}>`;
    }
    case "list-item":
      return `<li>${renderChildren(node.children)}</li>`;
    default:
      return renderChildren(node.children);
  }
}
function renderRichText(value) {
  if (!value) return "";
  try {
    return renderNode(JSON.parse(value));
  } catch {
    return "";
  }
}

// src/shared/algolia-rule-push/story-push.ts
var FIELD_STORIES = "stories";
var FIELD_INFO_CARD = "info_card";
var FIELD_MEDIA_DESKTOP2 = "media_desktop";
var FIELD_MEDIA_MOBILE2 = "media_mobile";
var FIELD_INTERNAL_NAME2 = "internal_name";
var FIELD_CONTENT_TYPE = "content_type";
var FIELD_OVERLAY_WHAT_TO_SHOW = "overlay_what_to_show";
var DEFAULT_DURATION = 6;
var DEFAULT_RATIO_DESKTOP = "16/9";
var DEFAULT_RATIO_MOBILE = "9/16";
var DEFAULT_CONTAINER = "container-full";
var DEFAULT_CARD_BACKGROUND = "#F8F8F8";
var MAX_HEIGHT_WIDE = 720;
var MAX_HEIGHT_SMALL = 480;
function colorBrightness(color) {
  const hex = color.trim().replace("#", "");
  const full = hex.length === 3 ? hex.split("").map((char) => char + char).join("") : hex;
  if (!/^[0-9a-f]{6}$/i.test(full)) return 255;
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16));
  return (r * 299 + g * 587 + b * 114) / 1e3;
}
function pickVideoSource(sources, maxHeight) {
  const under = sources.filter((source) => (source.height ?? 0) <= maxHeight);
  return under.length ? under.reduce(
    (best, source) => (source.height ?? 0) > (best.height ?? 0) ? source : best
  ) : sources.reduce(
    (best, source) => (source.height ?? 0) < (best.height ?? 0) ? source : best
  );
}
function toVideoVariant(media, maxHeight) {
  if (!media?.videoSources.length) return null;
  const source = pickVideoSource(media.videoSources, maxHeight);
  if (!source) return null;
  const posterWidth = clamp(source.width ?? 0, 480, 1280);
  return {
    poster: resizedImageUrl(media.url, posterWidth) ?? "",
    src: source.url,
    type: source.mimeType
  };
}
function toSegment(entry, maxHeight) {
  const desktop = metaobjectField(entry, FIELD_MEDIA_DESKTOP2)?.media ?? null;
  const mobile = metaobjectField(entry, FIELD_MEDIA_MOBILE2)?.media ?? null;
  if (!desktop && !mobile) return null;
  const primary = desktop ?? mobile;
  const kind = primary?.videoSources.length ? "video" : "image";
  const black = (key) => textOf(entry, key) === "black";
  const isBlack = (side) => black(`controls_color_${side}`) || black(`controls_colour_${side}`);
  const duration = numberOf(entry, "duration") || numberOf(entry, "duration_seconds");
  const card = toCard(
    metaobjectField(entry, FIELD_INFO_CARD)?.metaobject ?? null
  );
  const overlay = textOf(entry, FIELD_CONTENT_TYPE) || textOf(entry, FIELD_OVERLAY_WHAT_TO_SHOW);
  const wantsCard = overlay ? overlay === "info_card" : card !== null;
  const wantsButton = overlay ? overlay === "button" : card === null;
  return {
    // L'alternative appartient au FICHIER, pas au nom interne de l'entrée.
    alt: mobile?.altText || desktop?.altText || "",
    card: wantsCard ? card : null,
    cta: wantsButton ? toButton(entry) : null,
    duration: duration > 0 ? duration : DEFAULT_DURATION,
    fgDesktop: isBlack("desktop") ? "#000000" : "#ffffff",
    fgDesktopSubtle: isBlack("desktop") ? "#717171" : "#c8c8c8",
    fgMobile: isBlack("mobile") ? "#000000" : "#ffffff",
    fgMobileSubtle: isBlack("mobile") ? "#717171" : "#c8c8c8",
    imageDesktop: desktop?.url ?? "",
    imageMobile: mobile?.url ?? "",
    kind,
    videoDesktop: toVideoVariant(desktop, maxHeight),
    videoMobile: toVideoVariant(mobile, maxHeight)
  };
}
function toCard(entry) {
  if (!entry) return null;
  const title = textOf(entry, "title");
  const descriptionHtml = renderRichText(textOf(entry, "description"));
  if (!title && !descriptionHtml) return null;
  const icon = metaobjectField(entry, "icon")?.media ?? null;
  return {
    descriptionHtml,
    iconAlt: icon?.altText ?? "",
    iconUrl: icon?.url ?? "",
    linkLabel: textOf(entry, "link_label"),
    // Pas de `plain_key` : sur `block_info_card` le champ texte s'appelle
    // `link_url`, donc exactement le préfixe.
    linkUrl: cascadeUrl(entry, "link_url"),
    title
  };
}
function toButton(entry) {
  const label = textOf(entry, "button_label");
  const url = cascadeUrl(entry, "button_url");
  if (!label || !url) return null;
  return {
    label,
    url,
    // Blanc par défaut : le bouton est toujours posé sur un visuel. Même règle
    // que `story-list.liquid`, les deux doivent rester d'accord.
    variant: textOf(entry, "button_variant") === "dark" ? "v-dark" : "v-light"
  };
}
function toStoryPush(entry) {
  const stories = metaobjectField(entry, FIELD_STORIES)?.references ?? [];
  if (!stories.length) return null;
  const columnDesktop = numberOf(entry, "column_desktop");
  const columnMobile = numberOf(entry, "column_mobile");
  const positionDesktop = numberOf(entry, "position_desktop");
  const positionMobile = numberOf(entry, "position_mobile");
  const { spanDesktop } = placePush({
    columnDesktop,
    columnMobile,
    positionDesktop,
    positionMobile
  });
  const maxHeight = spanDesktop < 4 ? MAX_HEIGHT_SMALL : MAX_HEIGHT_WIDE;
  const segments = stories.map((story) => toSegment(story, maxHeight)).filter((segment) => segment !== null);
  if (!segments.length) return null;
  const cardBackground = textOf(entry, "card_background_color") || DEFAULT_CARD_BACKGROUND;
  return {
    autoLoop: booleanOf(entry, "auto_loop"),
    cardBackground,
    cardForeground: colorBrightness(cardBackground) < 128 ? "#ffffff" : "#000000",
    columnDesktop,
    columnMobile,
    containerDesktop: textOf(entry, "container_desktop") || DEFAULT_CONTAINER,
    containerMobile: textOf(entry, "container_mobile") || DEFAULT_CONTAINER,
    handle: entry.handle,
    internalName: textOf(entry, FIELD_INTERNAL_NAME2),
    positionDesktop,
    positionMobile,
    ratioDesktop: textOf(entry, "ratio_desktop") || DEFAULT_RATIO_DESKTOP,
    ratioMobile: textOf(entry, "ratio_mobile") || DEFAULT_RATIO_MOBILE,
    segments
  };
}

// src/shared/algolia-rule-push/metaobject-push.ts
var SEARCH_PUSH_KEY = "search_push_list";
var EXPLORE_PUSH_KEY = "explore_push";
var PUSH_COLLECTION_KEY = "push_collection";
var STORY_LIST_KEY = "block_story_list";
var TYPE_BLOCK_STORY_LIST = "block_story_list";
var TYPE_LIST_PUSH_SEARCH = "list_push_search";
var TYPE_PUSH_COLLECTION = "push_collection";
var TYPE_PUSH_EXPLORE = "push_explore";
var FIELD_LIST_OF_PUSH = "list_of_push";
var MEDIA_FIELDS = ["media", "image"];
var FIELD_POSITION = "position";
var FIELD_INTERNAL_NAME3 = "internal_name";
var FIELD_COLUMNS = "columns";
var FIELD_TITLE2 = "title";
var FIELD_DESCRIPTION2 = "description";
var FIELD_LINK_LABEL2 = "link_label";
var LINK_FIELDS = ["link_product", "link_collection", "link_page"];
var FIELD_LINK_URL = "link_url";
function isRecord2(value) {
  return value !== null && typeof value === "object";
}
function parseEntry(entry) {
  if (typeof entry !== "string") return entry;
  try {
    return JSON.parse(entry);
  } catch {
    return entry;
  }
}
function readPushHandles(userData, key) {
  const handles2 = [];
  const walk = (value) => {
    const parsed = parseEntry(value);
    if (Array.isArray(parsed)) {
      parsed.forEach(walk);
      return;
    }
    if (!isRecord2(parsed)) return;
    const raw = parsed[key];
    const candidates = Array.isArray(raw) ? raw : [raw];
    for (const candidate of candidates) {
      if (typeof candidate !== "string") continue;
      const handle = candidate.trim();
      if (handle && !handles2.includes(handle)) handles2.push(handle);
    }
  };
  walk(userData);
  return handles2;
}
function emptyPush() {
  return {
    buttonLabel: "",
    buttonSize: "v-large",
    buttonType: "v-primary",
    buttonUrl: "#",
    buttonVariant: "v-dark",
    columns: "",
    description: "",
    imageAlt: "",
    imageDesktop: "",
    imageMobile: "",
    video: "",
    linkLabel: "",
    linkStyle: "v-primary",
    linkUrl: "#",
    order: null,
    ratioDesktop: "",
    ratioMobile: "",
    sectionHeading: "",
    title: ""
  };
}
function positionOf(value) {
  const position = Number(value);
  return Number.isInteger(position) && position > 0 ? position : null;
}
function textOf2(entry, key) {
  return metaobjectField(entry, key)?.value ?? "";
}
function linkOf(entry) {
  for (const key of LINK_FIELDS) {
    const field = metaobjectField(entry, key);
    const url = resourceUrl(field?.resource);
    if (url) return url;
    if (field?.value) {
      console.warn(
        "[algolia-push] r\xE9f\xE9rence non r\xE9solue \u2014 scope Storefront manquant ?",
        { handle: entry.handle, key, value: field.value }
      );
    }
  }
  return normalizeUrl(metaobjectField(entry, FIELD_LINK_URL)?.value ?? "") || "#";
}
function mediaOf(entry) {
  for (const key of MEDIA_FIELDS) {
    const media = metaobjectField(entry, key)?.media;
    if (media) return media;
  }
  return null;
}
function labelOf(entry, altText, title = "") {
  return altText || title || textOf2(entry, FIELD_INTERNAL_NAME3);
}
function toSearchPush(entry) {
  const media = mediaOf(entry);
  if (!media) return null;
  const url = linkOf(entry);
  return {
    ...emptyPush(),
    buttonUrl: url,
    columns: textOf2(entry, FIELD_COLUMNS),
    // Labels the link without rendering a visible heading, which `title` would.
    imageAlt: labelOf(entry, media.altText),
    imageDesktop: media.url,
    imageMobile: media.url,
    linkUrl: url,
    order: positionOf(textOf2(entry, FIELD_POSITION)),
    video: media.videoUrl
  };
}
function toExplorePush(entry) {
  const media = mediaOf(entry);
  if (!media) return null;
  const url = linkOf(entry);
  const title = textOf2(entry, FIELD_TITLE2);
  return {
    ...emptyPush(),
    buttonUrl: url,
    description: textOf2(entry, FIELD_DESCRIPTION2),
    imageAlt: labelOf(entry, media.altText, title),
    imageDesktop: media.url,
    imageMobile: media.url,
    linkLabel: textOf2(entry, FIELD_LINK_LABEL2),
    linkUrl: url,
    title,
    video: media.videoUrl
  };
}
async function resolveHandles(handles2, resolve) {
  if (!handles2.length) return [];
  const resolved = await Promise.all(handles2.map(resolve));
  return resolved.flat();
}
function resolveByType(config, userData, key, type, map) {
  return resolveHandles(readPushHandles(userData, key), async (handle) => {
    const entry = await fetchMetaobject(config, { handle, type });
    const mapped = entry ? map(entry) : null;
    return mapped ? [mapped] : [];
  });
}
function hasSearchPushHandles(userData) {
  return [SEARCH_PUSH_KEY, PUSH_COLLECTION_KEY, STORY_LIST_KEY].some(
    (key) => readPushHandles(userData, key).length > 0
  );
}
async function resolveSearchPushes(config, userData) {
  const [rules, placed, stories] = await Promise.all([
    resolveHandles(
      readPushHandles(userData, SEARCH_PUSH_KEY),
      async (handle) => {
        const list = await fetchMetaobject(config, {
          handle,
          type: TYPE_LIST_PUSH_SEARCH
        });
        const entries = metaobjectField(list, FIELD_LIST_OF_PUSH)?.references ?? [];
        return entries.map(toSearchPush).filter((push) => push !== null);
      }
    ),
    resolveByType(
      config,
      userData,
      PUSH_COLLECTION_KEY,
      TYPE_PUSH_COLLECTION,
      toPlacedPush
    ),
    resolveByType(
      config,
      userData,
      STORY_LIST_KEY,
      TYPE_BLOCK_STORY_LIST,
      toStoryPush
    )
  ]);
  rules.sort(
    (a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER)
  );
  return { placed, rules, stories };
}
function resolveExplorePushes(config, userData) {
  return resolveHandles(
    readPushHandles(userData, EXPLORE_PUSH_KEY),
    async (handle) => {
      const entry = await fetchMetaobject(config, {
        handle,
        type: TYPE_PUSH_EXPLORE
      });
      const push = entry ? toExplorePush(entry) : null;
      return push ? [push] : [];
    }
  );
}

// src/shared/algolia/redirect.ts
var REDIRECT_LOOKUP_TIMEOUT_MS = 1e3;
var USER_DATA_REDIRECT_KEY = "redirect";
function isRecord3(value) {
  return value !== null && typeof value === "object";
}
function readRedirectUrl(result) {
  if (!result) return "";
  const { renderingContent } = result;
  const redirect = isRecord3(renderingContent) ? renderingContent.redirect : void 0;
  const url = isRecord3(redirect) ? redirect.url : void 0;
  if (typeof url === "string" && url.trim()) return url.trim();
  return readPushHandles(result.userData, USER_DATA_REDIRECT_KEY)[0] ?? "";
}
function safeRedirectUrl(raw) {
  const normalized = normalizeUrl(raw.trim());
  if (!normalized || normalized.startsWith("#")) return "";
  let target;
  try {
    target = new URL(normalized, window.location.origin);
  } catch {
    return "";
  }
  if (target.protocol === "https:") return target.href;
  if (target.protocol === "http:" && target.origin === window.location.origin) {
    return target.href;
  }
  return "";
}
async function lookupRedirect(client, {
  filters,
  indexName,
  query,
  ruleContexts
}) {
  try {
    const response = await client.search([
      {
        indexName,
        params: {
          query,
          hitsPerPage: 0,
          attributesToRetrieve: [],
          attributesToHighlight: [],
          analytics: false,
          clickAnalytics: false,
          responseFields: ["query", "userData", "renderingContent"],
          ruleContexts,
          ...filters ? { filters } : {}
        }
      }
    ]);
    const results = isRecord3(response) ? response.results : void 0;
    const result = Array.isArray(results) ? results[0] : void 0;
    return safeRedirectUrl(
      readRedirectUrl(isRecord3(result) ? result : null)
    );
  } catch {
    return "";
  }
}
function withTimeout(promise, ms, fallback) {
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(fallback), ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      () => {
        clearTimeout(timer);
        resolve(fallback);
      }
    );
  });
}

// src/shared/algolia-rule-push/PushCollectionCard.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "preact/jsx-runtime";
var MOBILE_WIDTHS = [400, 600, 800, 1e3];
var DESKTOP_WIDTHS = [400, 600, 800, 1200, 1600, 2e3];
var WIDE_VIEWPORT = "(min-width: 1024px)";
function isWideViewport() {
  return typeof window.matchMedia !== "function" || window.matchMedia(WIDE_VIEWPORT).matches;
}
function srcSet(url, widths) {
  return widths.map((width) => `${resizedImageUrl(url, width)} ${width}w`).join(", ");
}
function BulletIcon() {
  return /* @__PURE__ */ jsx3(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "17",
      height: "16",
      viewBox: "0 0 17 16",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx3(
        "path",
        {
          d: "M9.5 8C9.5 8.55228 9.05228 9 8.5 9C7.94772 9 7.5 8.55228 7.5 8C7.5 7.44772 7.94772 7 8.5 7C9.05228 7 9.5 7.44772 9.5 8Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function PushMedia({
  push,
  spanDesktop
}) {
  const desktop = push.imageDesktop;
  const mobile = push.imageMobile || desktop;
  const wide = isWideViewport();
  const videoUrl = wide ? push.videoDesktop || push.videoMobile : push.videoMobile || push.videoDesktop;
  if (videoUrl) {
    const video = /* @__PURE__ */ jsx3("div", { class: "container-video v-fill", children: /* @__PURE__ */ jsx3(
      "video",
      {
        src: videoUrl,
        poster: (wide ? desktop : mobile) || void 0,
        autoplay: true,
        muted: true,
        loop: true,
        playsinline: true,
        preload: "metadata",
        "aria-label": push.imageAlt || void 0
      }
    ) });
    return push.visualUrl ? /* @__PURE__ */ jsx3(
      "a",
      {
        class: "push-collection__visual-link",
        href: push.visualUrl,
        "aria-label": push.imageAlt || void 0,
        children: video
      }
    ) : video;
  }
  if (!desktop) return null;
  const picture = /* @__PURE__ */ jsxs2("picture", { children: [
    mobile ? /* @__PURE__ */ jsx3(
      "source",
      {
        media: "(max-width: 1023px)",
        srcset: srcSet(mobile, MOBILE_WIDTHS),
        sizes: "auto"
      }
    ) : null,
    /* @__PURE__ */ jsx3(
      "img",
      {
        src: resizedImageUrl(desktop, spanDesktop >= 4 ? 1920 : 720) ?? desktop,
        srcset: srcSet(desktop, DESKTOP_WIDTHS),
        sizes: "auto",
        alt: "",
        loading: "lazy",
        decoding: "async"
      }
    )
  ] });
  return push.visualUrl ? /* @__PURE__ */ jsx3(
    "a",
    {
      class: "test-container-image",
      href: push.visualUrl,
      "aria-label": push.imageAlt || void 0,
      children: picture
    }
  ) : /* @__PURE__ */ jsx3("div", { class: "test-container-image", children: picture });
}
function PushButton({ push }) {
  if (!push.buttonLabel || !push.buttonUrl) return null;
  return /* @__PURE__ */ jsx3("div", { class: "container-button", children: /* @__PURE__ */ jsx3(
    "a",
    {
      class: "cta v-primary v-large v-light v-margin-top",
      href: push.buttonUrl,
      target: push.buttonNewTab ? "_blank" : "_self",
      rel: push.buttonNewTab ? "noopener noreferrer" : "_self",
      children: /* @__PURE__ */ jsxs2("span", { class: "cta--label", children: [
        /* @__PURE__ */ jsx3(BulletIcon, {}),
        /* @__PURE__ */ jsx3("span", { class: "cta--label__text", children: push.buttonLabel }),
        /* @__PURE__ */ jsx3(BulletIcon, {})
      ] })
    }
  ) });
}
function PushCollectionCard({ push }) {
  const placement = placePush(push);
  const hasContent = Boolean(push.title || push.description || push.linkLabel);
  const style = [
    `--push-row-mobile: ${placement.rowMobile}`,
    `--push-col-mobile: ${placement.colMobile}`,
    `--push-span-mobile: ${placement.spanMobile}`,
    `--push-row-desktop: ${placement.rowDesktop}`,
    `--push-col-desktop: ${placement.colDesktop}`,
    `--push-span-desktop: ${placement.spanDesktop}`,
    push.ratioMobile ? `--push-ratio-mobile: ${push.ratioMobile}` : "",
    push.ratioDesktop ? `--push-ratio-desktop: ${push.ratioDesktop}` : ""
  ].filter(Boolean).join("; ");
  return /* @__PURE__ */ jsxs2("c-media-card", { class: "media-card push-collection", style, children: [
    /* @__PURE__ */ jsxs2("div", { class: "push-collection__media media-container", children: [
      /* @__PURE__ */ jsx3(PushMedia, { push, spanDesktop: placement.spanDesktop }),
      /* @__PURE__ */ jsx3(PushButton, { push })
    ] }),
    hasContent ? /* @__PURE__ */ jsx3("div", { class: "content-container", children: /* @__PURE__ */ jsxs2("div", { class: "inside", children: [
      push.title || push.description ? /* @__PURE__ */ jsxs2("div", { class: "inside__top", children: [
        push.title ? /* @__PURE__ */ jsx3("h3", { class: "label-m-alternate", children: push.title }) : null,
        push.description ? /* @__PURE__ */ jsx3("div", { class: "body-m-light color-secondary description", children: push.description }) : null
      ] }) : null,
      push.linkLabel && push.linkUrl ? /* @__PURE__ */ jsx3("div", { class: "inside__bottom", children: /* @__PURE__ */ jsx3("a", { class: "link v-primary", href: push.linkUrl, children: /* @__PURE__ */ jsx3("span", { class: "cta--label", children: /* @__PURE__ */ jsx3("span", { class: "cta--label__text", children: push.linkLabel }) }) }) }) : null
    ] }) }) : null
  ] });
}

// src/shared/algolia-rule-push/story-list-markup.ts
var DESKTOP_WIDTHS2 = [600, 900, 1200, 1600, 1920];
var MOBILE_WIDTHS2 = [400, 600, 800, 1024, 1400, 1920];
function srcSet2(url, widths) {
  return widths.map((width) => `${resizedImageUrl(url, width)} ${width}w`).join(", ");
}
function variantClasses(story) {
  const classes = [
    story.containerDesktop === "container-padded" ? "v-container-padded-desktop" : "v-container-full-width-desktop",
    story.containerMobile === "container-padded" ? "v-container-padded-mobile" : "v-container-full-width-mobile",
    // Le côté des cartes suit le CADRAGE et non le point de rupture : un module
    // en 9/16 desktop les centre comme en mobile.
    story.ratioDesktop === "16/9" ? "v-cards-inline-end" : "",
    // Toujours placé : sur cette surface le module est une tuile de la grille.
    "v-placed"
  ];
  return classes.filter(Boolean).join(" ");
}
function renderPicture(segment) {
  const fallback = segment.imageMobile || segment.imageDesktop;
  const both = segment.imageDesktop && segment.imageMobile;
  return `<div class='story-list__variant'>
      <picture>
        ${both ? `<source media='(min-width: 1024px)' srcset='${escapeHtml(srcSet2(segment.imageDesktop, DESKTOP_WIDTHS2))}' sizes='100vw'>` : ""}
        <img
          src='${escapeHtml(resizedImageUrl(fallback, 1920) ?? fallback)}'
          srcset='${escapeHtml(srcSet2(fallback, MOBILE_WIDTHS2))}'
          sizes='100vw'
          alt='${escapeHtml(segment.alt)}'
          loading='lazy'
          decoding='async'
        >
      </picture>
    </div>`;
}
function renderVideos(segment, isFirst) {
  return ["desktop", "mobile"].map((variant) => {
    const video = variant === "desktop" ? segment.videoDesktop : segment.videoMobile;
    if (!video) return "";
    const posterAttr = video.poster ? `${isFirst ? "poster" : "data-poster"}='${escapeHtml(video.poster)}'` : "";
    return `<div class='story-list__variant' data-variant='${variant}'>
        <video playsinline muted preload='none' ${posterAttr}>
          <source src='${escapeHtml(video.src)}' type='${escapeHtml(video.type)}'>
        </video>
      </div>`;
  }).join("");
}
function renderCard(card) {
  const link = card.linkUrl && card.linkLabel ? `<a class='link v-primary' href='${escapeHtml(card.linkUrl)}'>
          <span class='cta--label'>
            <span class='cta--label__text'>${escapeHtml(card.linkLabel)}</span>
          </span>
        </a>` : "";
  return `<div class='story-list__cards'>
      <div class='story-list__card'>
        <c-info-card class='info-card'>
          ${card.iconUrl ? `<div class='icon-container'>
            <img src='${escapeHtml(card.iconUrl)}' alt='${escapeHtml(card.iconAlt)}' loading='lazy' decoding='async'>
          </div>` : ""}
          <div class='content-container'>
            ${card.title ? `<h3 class='label-m-regular'>${escapeHtml(card.title)}</h3>` : ""}
            ${card.descriptionHtml ? `<div class='body-m-light'>${card.descriptionHtml}</div>` : ""}
            ${link}
          </div>
        </c-info-card>
      </div>
    </div>`;
}
function renderCta2(cta) {
  return `<div class='story-list__cards'>
      <div class='story-list__cta'>
        <a class='cta v-primary v-large ${cta.variant} v-fit' href='${escapeHtml(cta.url)}'>
          <span class='cta--label'>
            ${ICON_BULLET}
            <span class='cta--label__text'>${escapeHtml(cta.label)}</span>
            ${ICON_BULLET}
          </span>
        </a>
      </div>
    </div>`;
}
function renderSegment(segment, index) {
  const isFirst = index === 0;
  return `<div
      class='story-list__segment'
      data-story-slot='${index}'
      data-duration='${segment.duration}'
      data-kind='${segment.kind}'
      data-fg-desktop='${escapeHtml(segment.fgDesktop)}'
      data-fg-subtle-desktop='${escapeHtml(segment.fgDesktopSubtle)}'
      data-fg-mobile='${escapeHtml(segment.fgMobile)}'
      data-fg-subtle-mobile='${escapeHtml(segment.fgMobileSubtle)}'
      ${isFirst ? "" : "hidden"}
    >
      ${segment.kind === "image" ? renderPicture(segment) : renderVideos(segment, isFirst)}
      ${segment.card ? renderCard(segment.card) : segment.cta ? renderCta2(segment.cta) : ""}
    </div>`;
}
function renderStoryList(story, assets) {
  const placement = placePush(story);
  const count = story.segments.length;
  const style = [
    `--story-ratio-mobile: ${story.ratioMobile}`,
    `--story-ratio-desktop: ${story.ratioDesktop}`,
    `--bg-info-card: ${story.cardBackground}`,
    `--story-card-fg: ${story.cardForeground}`,
    `--story-row-mobile: ${placement.rowMobile}`,
    `--story-col-mobile: ${placement.colMobile}`,
    `--story-span-mobile: ${placement.spanMobile}`,
    `--story-row-desktop: ${placement.rowDesktop}`,
    `--story-col-desktop: ${placement.colDesktop}`,
    `--story-span-desktop: ${placement.spanDesktop}`
  ].join("; ");
  const labelPosition = assets.labelPositionTemplate.replace(
    "__COUNT__",
    String(count)
  );
  return `<c-story-list
    class='story-list ${variantClasses(story)}'
    role='group'
    aria-label='${escapeHtml(assets.labelStory)}'
    style='${escapeHtml(style)}'
    data-internal-name='${escapeHtml(story.internalName)}'
    data-story-count='${count}'
    data-auto-loop='${story.autoLoop}'
    data-label-play='${escapeHtml(assets.labelPlay)}'
    data-label-pause='${escapeHtml(assets.labelPause)}'
    data-label-mute='${escapeHtml(assets.labelMute)}'
    data-label-unmute='${escapeHtml(assets.labelUnmute)}'
    data-label-replay='${escapeHtml(assets.labelReplay)}'
    data-label-story='${escapeHtml(assets.labelStory)}'
    data-label-position='${escapeHtml(labelPosition)}'
  >
    <div class='story-list__media'>
      <div class='story-list__topbar'>
        <div class='story-list__controls'>
          <button class='story-btn' type='button' data-play-btn aria-label='${escapeHtml(assets.labelPause)}'>
            <span class='story-btn__icon' data-icon-play hidden>${assets.playIcon}</span>
            <span class='story-btn__icon' data-icon-pause>${assets.pauseIcon}</span>
            <span class='story-btn__icon' data-icon-restart hidden>${assets.restartIcon}</span>
          </button>
          <button class='story-btn' type='button' data-mute-btn aria-label='${escapeHtml(assets.labelUnmute)}'>
            <span class='story-btn__icon' data-icon-muted>${assets.mutedIcon}</span>
            <span class='story-btn__icon' data-icon-unmuted hidden>${assets.unmutedIcon}</span>
          </button>
        </div>
        <div class='story-list__bars' aria-hidden='true'>
          ${story.segments.map(
    (_, index) => `<div class='story-bar' data-story-bar='${index}'><span class='story-bar__fill'></span></div>`
  ).join("")}
        </div>
        ${count > 1 ? `<div class='story-list__nav'>
          <button class='story-btn story-btn--nav' type='button' data-story-prev aria-label='${escapeHtml(assets.labelPrev)}'>${assets.chevronPrevIcon}</button>
          <button class='story-btn story-btn--nav' type='button' data-story-next aria-label='${escapeHtml(assets.labelNext)}'>${assets.chevronNextIcon}</button>
        </div>` : ""}
      </div>
      <div class='story-list__stage' data-story-stage>
        ${story.segments.map(renderSegment).join("")}
      </div>
      <div class='story-list__surface' data-story-surface aria-hidden='true'></div>
      <p class='sr-only' data-story-status aria-live='polite' aria-atomic='true'></p>
    </div>
  </c-story-list>`;
}
export {
  ALGOLIA_HIDDEN_GUARD_CONTEXT,
  ALGOLIA_HIDDEN_PRODUCTS_FILTER,
  ALGOLIA_PRODUCT_ATTRIBUTES_TO_RETRIEVE,
  ALGOLIA_PRODUCT_RESPONSE_FIELDS,
  AddToCartInputs,
  CDN_ALGOLIASEARCH,
  CDN_AUTOCOMPLETE_CORE,
  CDN_INSTANTSEARCH,
  DEFAULT_CARD_ASSETS,
  EXPLORE_PUSH_KEY,
  ICON_BULLET,
  ICON_CROSS_SVG,
  ICON_MINUS,
  ICON_PLUS,
  PUSH_COLLECTION_KEY,
  ProductCard,
  PushCollectionCard,
  REDIRECT_LOOKUP_TIMEOUT_MS,
  SEARCH_DEBOUNCE_MS,
  SEARCH_PUSH_KEY,
  SRI_ALGOLIASEARCH,
  SRI_AUTOCOMPLETE_CORE,
  SRI_INSTANTSEARCH,
  STORY_LIST_KEY,
  contenanceOf,
  escapeHtml,
  fetchMetaobject,
  formIdFor,
  formatModelsLabel,
  getRulePushes,
  giftFromHit,
  giftedHandles,
  giftedVersion,
  hasGiftInCart,
  hasSearchPushHandles,
  hoverImageUrl,
  invalidateGiftedHandles,
  isGiftEligible,
  isSetToComposeProduct,
  isVirtualSetProduct,
  itemUrl,
  joinRootUrl,
  loadScript,
  localizedMetaobjectLabel,
  lookupRedirect,
  metaobjectField,
  minimumQueryLength,
  normalizeUrl,
  orderRulePushSlots,
  otherModelsCount,
  parseShortQueries,
  placePush,
  preorderButtonLabel,
  preorderDateOf,
  preorderStrings,
  productAttributesToRetrieve,
  productInfoParts,
  productTagLabels,
  readPushHandles,
  readRedirectUrl,
  readStorefrontConfig,
  refreshGiftedHandles,
  renderCards,
  renderProductPrice,
  renderRulePush,
  renderRulePushIconic,
  renderRulePushIconics,
  renderStoryList,
  resolveExplorePushes,
  resolveGiftsForHits,
  resolveSearchPushes,
  safeRedirectUrl,
  searchUrlFor,
  shopifyRoot,
  virtualSetBundleId,
  virtualSetChildVariantIds,
  withTimeout
};
